export enum ArchiveAtTypeEnum {
  START_OF_JOB = 'START_OF_JOB',
  END_OF_JOB = 'END_OF_JOB',
}
